import request from '@/utils/httpRequest'

//登录
export function login(obj) {
  return request({
    url: '/api/login',
    method: 'post',
    data: obj,
  })
}

//微信授权登录
export function loginByWechat(obj) {
  return request({
    url: '/api/loginWechat',
    method: 'post',
    data: obj,
  })
}

//关联账号
export function relationPPN(obj) {
  return request({
    url: '/api/relation',
    method: 'post',
    data: obj,
  })
}

//用户信息
export function getUserInfo(obj) {
  return request({
    url: '/api/getUser',
    method: 'get',
    params: obj,
  })
}

//轮播图
export function getBanner() {
  return request({
    url: '/api/bsd/banner/list',
    method: 'get',
  })
}

//数据字典
export function getDictType(dictType) {
  return request({
    url: `/api/system/dict/type/${dictType}`,
    method: 'get',
  })
}

//获取邮箱
export function getEmail() {
  return request({
    url: `/api/system/config/email`,
    method: 'get',
  })
}

//退出
export function logoutPPN() {
  return request({
    url: '/api/returnLogin',
    method: 'post',
    data: {},
  })
}
